import React, {Component} from 'react';
import CardWidget from "../card-widget/CardWidget";
import {RouteConstants} from "../route/services/RouteConstants";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import { getLanguage } from "../../store/rootReducer";
import {connect} from "react-redux";

class CompleteRegistrationRequestEmailSentSection extends Component {

    goToLoginScreen = () => {
        this.props.history.push(RouteConstants.LOGIN);
    };


    getCompleteRegistrationRequestEmailSentSectionContent = () => {
        return (
            <CardWidgetContent contentText="incomplete_registration.complete_registration_request_email_sent"/>
        )
    };

    render() {
        return (
            <CardWidget
                getCardContent={this.getCompleteRegistrationRequestEmailSentSectionContent}
                submitButtonAction={this.goToLoginScreen}
                submitButtonText="incomplete_registration.ok"
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: getLanguage(state)
    };
};


export default connect(mapStateToProps) (CompleteRegistrationRequestEmailSentSection);